"use client"

import styled from "@emotion/styled"
import { Button } from "@mui/material"
import Image from "next/image"
import { useRouter } from "next/navigation"

const StyledButton = styled(Button)`
  display: flex;
  width: 52px;
  height: 52px;
  padding: 10px 14px 10px 14px;
  justify-content: center;
  align-items: center;
  border-radius: 300px;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.16);
  min-width: 0;
  margin: 0;
  :hover {
  }
`

export default function ShareButton() {
  const router = useRouter()

  const handleShare = async () => {
    const currentUrl = window.location.href

    if (navigator.share) {
      try {
        await navigator.share({
          title: "רכב למכירה",
          url: currentUrl,
        })
      } catch (error) {
        console.log("Error sharing:", error)
      }
    } else {
      // Fallback: copy to clipboard
      try {
        await navigator.clipboard.writeText(currentUrl)
        // You might want to show a toast notification here
        alert("הקישור הועתק ללוח")
      } catch (error) {
        console.log("Error copying to clipboard:", error)
      }
    }
  }

  return (
    <StyledButton variant="primary" onClick={handleShare}>
      <Image src="/icons/share.svg" alt="share" width={27} height={32} />
    </StyledButton>
  )
}
